/**
 * Unseen-arrivals model. A fire is keyed by its `moment` (the ISO `fire_ts`) rather than
 * row_key, so the promoted "live" fire, which carries a moment but no row_key, is addressable.
 *
 * Only SSE-pushed arrivals (the realtime `reconcile` path) mark a fire; the on-load overlay
 * and local ↻ do not, so pre-existing fires never pulse.
 *
 * Transforms are immutable, but a no-op returns the SAME reference so a duplicate or
 * idempotent event doesn't churn React.
 */

export function markArrived(set, moment) {
  if (!moment || set.has(moment)) return set;
  const next = new Set(set);
  next.add(moment);
  return next;
}

export function acknowledge(set, moment) {
  if (!moment || !set.has(moment)) return set;
  const next = new Set(set);
  next.delete(moment);
  return next;
}

export function isUnseen(set, moment) {
  return !!moment && set.has(moment);
}

export function hasUnseen(set) {
  return set.size > 0;
}
